import api from "../services/api";

import { IGerenteSetor, ISearchRequest, ISearchResponse } from "../interfaces";

export interface ISectorManagerListModel {
    id?: string;
    status: number;
    data: string;
    devedor: number;
    cpf: string;
    nome: string;
    gerenteRegional: string;
    gerenteRegionalId: string;
    cidade: string;
}

interface ISectorManagerToConferenceRequest {
    searchRequest: ISearchRequest;
    status: string;
}

class SectorManagerRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<ISectorManagerListModel>> => {

        const response = await api.get<ISearchResponse<ISectorManagerListModel>>("gerentesetor", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public ListToConference = async (conferenceRequest: ISectorManagerToConferenceRequest): Promise<ISearchResponse<ISectorManagerListModel>> => {

        const { searchRequest, status } = conferenceRequest;

        const response = await api.get<ISearchResponse<ISectorManagerListModel>>(`gerentesetor/conference`, {
            params: {
                status: status,
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public GetById = async (id: string): Promise<IGerenteSetor> => {
        const response = await api.get<IGerenteSetor>(`gerentesetor/${id}`);

        return response.data;
    }
}

const sectorManagerRepository = new SectorManagerRepository();
export default sectorManagerRepository;
